/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestasPacPacientePreguntasModelDto } from '../../models/encuestas-pac-paciente-preguntas-model-dto';

export interface EncuestasControllerDetalleEncuestaPaciente$Params {

/**
 * UUID de la encuesta del paciente
 */
  uuidEncuesta: string;
}

export function encuestasControllerDetalleEncuestaPaciente(http: HttpClient, rootUrl: string, params: EncuestasControllerDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestasPacPacientePreguntasModelDto>> {
  const rb = new RequestBuilder(rootUrl, encuestasControllerDetalleEncuestaPaciente.PATH, 'get');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EncuestasPacPacientePreguntasModelDto>;
    })
  );
}

encuestasControllerDetalleEncuestaPaciente.PATH = '/api/paciente-encuestas/encuestas-paciente/{uuidEncuesta}';
